import { Component, Input, input } from "@angular/core";
import { WkTranslatePipe } from "@shared/index";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "app-loader",
    templateUrl: "./app-loader.component.html",
    styleUrl: "./app-loader.component.scss",
    host: { class: "wk-app-loader" },
    imports: [WkTranslatePipe, JumpstartComponentsModule],
})
export class AppLoaderComponent {
    @Input() text = "";
    @Input() isOverlay = true;
    @Input() size: "small" | "medium" | "large" | "button" = "large";
    @Input() position: "right" | "left" = "right";

    isLoading = input<boolean>(true);
}
